import { OccConfig } from './occ-config';

export const defaultOccConfig: OccConfig = {
  backend: {
    occ: {
      prefix: '/rest/v2/',
    },
    media: {},
  },
};
